import React, {useContext, useState} from "react";
import {motion} from "framer-motion";
import "./Contact.scss";
import {contactInfo, socialMediaLinks} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {fadeUp, vp} from "../../utils/animations";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  const [sent, setSent] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = e => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    fetch("https://formspree.io/f/movwprwl", {
      method: "POST",
      body: data,
      headers: {Accept: "application/json"}
    }).then(() => {
      setSent(true);
      setName("");
      setEmail("");
      setMessage("");
      form.reset();
      setTimeout(() => setSent(false), 5000);
    });
  };

  return (
    <motion.section
      className={`contact ${isDark ? "dark" : ""}`}
      id="contact"
      initial="hidden"
      whileInView="show"
      viewport={vp}
      variants={fadeUp}
    >
      <div className="contact__inner">
        {/* Left — info */}
        <motion.div className="contact__info" variants={fadeUp}>
          <span className="section-label">Contact</span>
          <h2 className="contact__title">{contactInfo.title}</h2>
          <p className="contact__sub">{contactInfo.subtitle}</p>

          <div className="contact__links">
            <a
              href={`mailto:${contactInfo.email_address}`}
              className="contact__link"
            >
              <span className="contact__link-label">Email</span>
              <span className="contact__link-val">
                {contactInfo.email_address}
              </span>
            </a>
            <a
              href={socialMediaLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="contact__link"
            >
              <span className="contact__link-label">LinkedIn</span>
              <span className="contact__link-val">
                linkedin.com/in/Srimon ↗
              </span>
            </a>
            <a
              href={socialMediaLinks.github}
              target="_blank"
              rel="noopener noreferrer"
              className="contact__link"
            >
              <span className="contact__link-label">GitHub</span>
              <span className="contact__link-val">
                github.com/Srimonchaari ↗
              </span>
            </a>
          </div>
        </motion.div>

        {/* Right — form */}
        <motion.form
          className="contact__form"
          onSubmit={handleSubmit}
          variants={fadeUp}
        >
          <input type="text" name="_gotcha" style={{display: "none"}} />

          <div className="form-row">
            <label htmlFor="cf-name">Name</label>
            <input
              id="cf-name"
              type="text"
              name="name"
              value={name}
              onChange={e => setName(e.target.value)}
              required
              placeholder="Your name"
              autoComplete="name"
            />
          </div>

          <div className="form-row">
            <label htmlFor="cf-email">Email</label>
            <input
              id="cf-email"
              type="email"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
              autoComplete="email"
            />
          </div>

          <div className="form-row">
            <label htmlFor="cf-message">Message</label>
            <textarea
              id="cf-message"
              name="message"
              rows="5"
              value={message}
              onChange={e => setMessage(e.target.value)}
              required
              placeholder="What's on your mind?"
            />
          </div>

          <button type="submit" className="contact__submit" disabled={sent}>
            {sent ? "Message sent ✓" : "Send Message"}
          </button>
        </motion.form>
      </div>
    </motion.section>
  );
}
